var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.779,
    height: 11.779,
    viewBox: "0 0 11.779 11.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-148.35 -128.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M153.871,128.02h.736c.075.01.151.02.226.028a5.91,5.91,0,0,1,5.2,4.846c.038.214.061.431.09.647v.736c-.018.144-.033.288-.054.432a5.912,5.912,0,0,1-4.81,5c-.217.039-.438.062-.657.092h-.736c-.144-.018-.288-.033-.431-.054a5.914,5.914,0,0,1-5-4.81c-.04-.218-.062-.439-.092-.658v-.736c.018-.144.033-.288.053-.432a5.911,5.911,0,0,1,4.822-5C153.439,128.073,153.656,128.05,153.871,128.02Zm.37,11.042a5.153,5.153,0,1,0-5.155-5.157A5.162,5.162,0,0,0,154.241,139.062Z",
    fill: "#2eb0a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M328.35,200.16h.733v.137q0,1.638,0,3.277a.242.242,0,0,0,.079.19q.966.961,1.929,1.925a1.137,1.137,0,0,0,.09.075l-.526.526c-.015-.014-.038-.033-.059-.055q-1.09-1.09-2.177-2.181a.233.233,0,0,1-.067-.145q-.006-1.84,0-3.68C328.347,200.211,328.349,200.192,328.35,200.16Z",
    transform: "translate(-174.475 -69.927)",
    fill: "#2eb0a2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5b062080f49293d3fee8f2ff6648fbc5.svg";
export { ForwardRef as ReactComponent };